import translate from "../../../common/Dictionary";
import checkFill from "../../../../img/icon_fill_check.svg";

const StepFive = ({ state, userData }) => {
    return (
        <div className="axa-project-card">
            <div className="axa-subcat-card-padding axa-card-shadow mt-4 bg-white">
                <img id="img-success-check" className="mt-9" src={checkFill} alt="success" style={{ height: "64px" }} />
                <div className="axa-service-card-title mt-3">{translate("newProjectConfirmationHeader", userData.language)}</div>
                <div className="axa-confirmation-title mt-1">{translate("newProjectConfirmationSubHeader", userData.language)}</div>
                <div className="axa-confirmation-text mt-4">{translate("newProjectConfirmationInformationText", userData.language)}</div>
                <div className="axa-confirmation-text mt-3">{translate("newProjectConfirmationEmailText", userData.language)}</div>
                <div className="axa-confirmation-email mt-2">{state.customerEmail}</div>
            </div>
        </div>
    );
};

export default StepFive;
